/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import IdNameVo from './IdNameVo';
import TextBookCategoryVo from './TextBookCategoryVo';
import TextbookTagVo from './TextbookTagVo';




  /**
   * The TextBookVo model module.
   * @module textbook/model/TextBookVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextBookVo</code>.
   * @alias module:textbook/model/TextBookVo
   * @class
   * @param id {Integer} id
   * @param title {String} 书名
   */
  var exports = function(id, title) {
    var _this = this;

    _this['id'] = id;


    _this['title'] = title;







































  };

  /**
   * Constructs a <code>TextBookVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextBookVo} obj Optional instance to populate.
   * @return {module:textbook/model/TextBookVo} The populated <code>TextBookVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'bookType')) {
        obj['bookType'] = ApiClient.convertToType(data['bookType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'bookFormat')) {
        obj['bookFormat'] = ApiClient.convertToType(data['bookFormat'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUrl')) {
        obj['thumbUrl'] = ApiClient.convertToType(data['thumbUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'cardBgUrl')) {
        obj['cardBgUrl'] = ApiClient.convertToType(data['cardBgUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'summary')) {
        obj['summary'] = ApiClient.convertToType(data['summary'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'note')) {
        obj['note'] = ApiClient.convertToType(data['note'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'infoUrl')) {
        obj['infoUrl'] = ApiClient.convertToType(data['infoUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'versionNum')) {
        obj['versionNum'] = ApiClient.convertToType(data['versionNum'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'md5')) {
        obj['md5'] = ApiClient.convertToType(data['md5'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'status')) {
        obj['status'] = ApiClient.convertToType(data['status'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publishTime')) {
        obj['publishTime'] = ApiClient.convertToType(data['publishTime'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'endTime')) {
        obj['endTime'] = ApiClient.convertToType(data['endTime'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'targetPoint')) {
        obj['targetPoint'] = ApiClient.convertToType(data['targetPoint'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtCreate')) {
        obj['gmtCreate'] = ApiClient.convertToType(data['gmtCreate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gmtModified')) {
        obj['gmtModified'] = ApiClient.convertToType(data['gmtModified'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'isbn')) {
        obj['isbn'] = ApiClient.convertToType(data['isbn'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'authors')) {
        obj['authors'] = ApiClient.convertToType(data['authors'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publishers')) {
        obj['publishers'] = ApiClient.convertToType(data['publishers'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'issuedDate')) {
        obj['issuedDate'] = ApiClient.convertToType(data['issuedDate'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'price')) {
        obj['price'] = ApiClient.convertToType(data['price'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'downloadable')) {
        obj['downloadable'] = ApiClient.convertToType(data['downloadable'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'chiefEditor')) {
        obj['chiefEditor'] = ApiClient.convertToType(data['chiefEditor'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'deputyEditor')) {
        obj['deputyEditor'] = ApiClient.convertToType(data['deputyEditor'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contributingAuthors')) {
        obj['contributingAuthors'] = ApiClient.convertToType(data['contributingAuthors'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producer')) {
        obj['producer'] = ApiClient.convertToType(data['producer'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producerCompanyId')) {
        obj['producerCompanyId'] = ApiClient.convertToType(data['producerCompanyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'producerCompany')) {
        obj['producerCompany'] = IdNameVo.constructFromObject(data['producerCompany']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'contactInfo')) {
        obj['contactInfo'] = ApiClient.convertToType(data['contactInfo'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'edition')) {
        obj['edition'] = ApiClient.convertToType(data['edition'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'eduStage')) {
        obj['eduStage'] = ApiClient.convertToType(data['eduStage'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'copyrightStatement')) {
        obj['copyrightStatement'] = ApiClient.convertToType(data['copyrightStatement'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publisherCompanyId')) {
        obj['publisherCompanyId'] = ApiClient.convertToType(data['publisherCompanyId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'publisherCompany')) {
        obj['publisherCompany'] = IdNameVo.constructFromObject(data['publisherCompany']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pdfFileUri')) {
        obj['pdfFileUri'] = ApiClient.convertToType(data['pdfFileUri'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pdfFileSize')) {
        obj['pdfFileSize'] = ApiClient.convertToType(data['pdfFileSize'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'forSale')) {
        obj['forSale'] = ApiClient.convertToType(data['forSale'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'aiTextbook')) {
        obj['aiTextbook'] = ApiClient.convertToType(data['aiTextbook'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'standardType')) {
        obj['standardType'] = ApiClient.convertToType(data['standardType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'categories')) {
        obj['categories'] = ApiClient.convertToType(data['categories'], [TextBookCategoryVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'tags')) {
        obj['tags'] = ApiClient.convertToType(data['tags'], [TextbookTagVo]);
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 书籍类型 1:数字教材 2:电子书
   * @member {Integer} bookType
   */
  exports.prototype['bookType'] = undefined;
  /**
   * 电子书格式 0:App 100:自建H5 101:第三方H5 200:pdf
   * @member {Integer} bookFormat
   */
  exports.prototype['bookFormat'] = undefined;
  /**
   * 书名
   * @member {String} title
   */
  exports.prototype['title'] = undefined;
  /**
   * 封面
   * @member {String} thumbUrl
   */
  exports.prototype['thumbUrl'] = undefined;
  /**
   * 卡片背景图
   * @member {String} cardBgUrl
   */
  exports.prototype['cardBgUrl'] = undefined;
  /**
   * 简介
   * @member {String} summary
   */
  exports.prototype['summary'] = undefined;
  /**
   * 后台备注
   * @member {String} note
   */
  exports.prototype['note'] = undefined;
  /**
   * 教材简介url
   * @member {String} infoUrl
   */
  exports.prototype['infoUrl'] = undefined;
  /**
   * 压缩包版本号，用于升级
   * @member {String} versionNum
   */
  exports.prototype['versionNum'] = undefined;
  /**
   * 压缩包md5
   * @member {String} md5
   */
  exports.prototype['md5'] = undefined;
  /**
   * 0待发布；1上线；2下线
   * @member {Integer} status
   */
  exports.prototype['status'] = undefined;
  /**
   * 发布时间
   * @member {Date} publishTime
   */
  exports.prototype['publishTime'] = undefined;
  /**
   * 下线时间
   * @member {Date} endTime
   */
  exports.prototype['endTime'] = undefined;
  /**
   * 课程总积分
   * @member {Integer} targetPoint
   */
  exports.prototype['targetPoint'] = undefined;
  /**
   * 创建时间
   * @member {Date} gmtCreate
   */
  exports.prototype['gmtCreate'] = undefined;
  /**
   * 更新时间
   * @member {Date} gmtModified
   */
  exports.prototype['gmtModified'] = undefined;
  /**
   * ISBN号
   * @member {String} isbn
   */
  exports.prototype['isbn'] = undefined;
  /**
   * 作者名，逗号分隔
   * @member {String} authors
   */
  exports.prototype['authors'] = undefined;
  /**
   * 出版社，逗号分隔
   * @member {String} publishers
   */
  exports.prototype['publishers'] = undefined;
  /**
   * 实体书发布时间
   * @member {Date} issuedDate
   */
  exports.prototype['issuedDate'] = undefined;
  /**
   * 价格 单位分
   * @member {Integer} price
   */
  exports.prototype['price'] = undefined;
  /**
   * 是否可下载离线观看
   * @member {Boolean} downloadable
   */
  exports.prototype['downloadable'] = undefined;
  /**
   * 主编
   * @member {String} chiefEditor
   */
  exports.prototype['chiefEditor'] = undefined;
  /**
   * 副主编
   * @member {String} deputyEditor
   */
  exports.prototype['deputyEditor'] = undefined;
  /**
   * 参编人员
   * @member {String} contributingAuthors
   */
  exports.prototype['contributingAuthors'] = undefined;
  /**
   * 制作单位
   * @member {String} producer
   */
  exports.prototype['producer'] = undefined;
  /**
   * 制作单位id
   * @member {Integer} producerCompanyId
   */
  exports.prototype['producerCompanyId'] = undefined;
  /**
   * 制作单位
   * @member {module:textbook/model/IdNameVo} producerCompany
   */
  exports.prototype['producerCompany'] = undefined;
  /**
   * 教材联系
   * @member {String} contactInfo
   */
  exports.prototype['contactInfo'] = undefined;
  /**
   * 版次
   * @member {String} edition
   */
  exports.prototype['edition'] = undefined;
  /**
   * 1中职，2高职，3 中高职
   * @member {Integer} eduStage
   */
  exports.prototype['eduStage'] = undefined;
  /**
   * 版权声明
   * @member {String} copyrightStatement
   */
  exports.prototype['copyrightStatement'] = undefined;
  /**
   * 出版社id
   * @member {Integer} publisherCompanyId
   */
  exports.prototype['publisherCompanyId'] = undefined;
  /**
   * 出版社
   * @member {module:textbook/model/IdNameVo} publisherCompany
   */
  exports.prototype['publisherCompany'] = undefined;
  /**
   * PDF文件存储路径（bookType=2时使用）
   * @member {String} pdfFileUri
   */
  exports.prototype['pdfFileUri'] = undefined;
  /**
   * PDF文件大小（字节）
   * @member {Integer} pdfFileSize
   */
  exports.prototype['pdfFileSize'] = undefined;
  /**
   * 排序键（数字越小越靠前）
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;
  /**
   * 是否开放销售
   * @member {Boolean} forSale
   */
  exports.prototype['forSale'] = undefined;
  /**
   * 是否AI教材
   * @member {Boolean} aiTextbook
   */
  exports.prototype['aiTextbook'] = undefined;
  /**
   * 规划教材类型 0:无 1:国规 2:省规
   * @member {Integer} standardType
   */
  exports.prototype['standardType'] = undefined;
  /**
   * 关联的分类列表
   * @member {Array.<module:textbook/model/TextBookCategoryVo>} categories
   */
  exports.prototype['categories'] = undefined;
  /**
   * 标签列表
   * @member {Array.<module:textbook/model/TextbookTagVo>} tags
   */
  exports.prototype['tags'] = undefined;



  export default exports;
;


